document.addEventListener("DOMContentLoaded", function () {
    const bellBtn = document.getElementById("notification-bell-btn");
    const dropdown = document.getElementById("notification-dropdown");
    const closeBtn = document.getElementById("notification-close-btn");
    const badge = document.getElementById("notification-badge");
    const drawerHeaderCounter = document.getElementById("notification-drawer-counter");
    let isFirstOpen = true;  

    function updateNotificationBadge() {
        const unreadCount = parseInt(localStorage.getItem("unread_notifications") || "0", 10);
        console.log("🔄 Aktualizujem notifikačný badge:", unreadCount);

        if (unreadCount > 0) {
            badge.textContent = unreadCount;
            badge.classList.add("active");
        } else {
            badge.textContent = "";
            badge.classList.remove("active");
        }

        if (drawerHeaderCounter) {
            console.log("🎯 Nastavujem drawer counter:", unreadCount);
            drawerHeaderCounter.textContent = `( ${unreadCount} )`;
        }
    }

    function markNotificationsAsRead() {
        console.log("🗑️ Resetujem notifikácie ako prečítané!");

        localStorage.setItem("unread_notifications", "0");
        sessionStorage.setItem("notifications_seen", "true");

        updateNotificationBadge();

        if (drawerHeaderCounter) {
            drawerHeaderCounter.textContent = `( 0 )`;
        }

        document.querySelectorAll(".notification-item").forEach(item => {
            item.classList.add("read");
            item.classList.remove("unread"); // ✅ Odstránime triedu "unread"
        });
    }

    if (bellBtn && dropdown) {
        bellBtn.addEventListener("click", function (event) {
            event.stopPropagation();
            
            if (dropdown.classList.contains("hidden")) {
                dropdown.classList.remove("hidden");
                dropdown.classList.add("active");
            } else {
                dropdown.classList.add("hidden");
                dropdown.classList.remove("active");
                markNotificationsAsRead();
            }

            if (isFirstOpen) {
                console.log("🔵 Prvé otvorenie - neoznačujem ako prečítané!");
                isFirstOpen = false;
            }
        });

        if (closeBtn) {
            closeBtn.addEventListener("click", function () {
                dropdown.classList.add("hidden");
                dropdown.classList.remove("active");
                markNotificationsAsRead();
            });
        }
    }

    setInterval(updateNotificationBadge, 2000);
});

// ✅ Načítanie metafieldu zo stránky a uloženie do LocalStorage
document.addEventListener("DOMContentLoaded", function () {
    const notificationElement = document.getElementById("global-notifications");

    if (!notificationElement) {
        console.error("❌ Element #global-notifications neexistuje!");
        return;
    }

    let notifications = notificationElement.getAttribute("data-messages").trim();
    console.log("📥 Načítané notifikácie:", notifications);

    let unreadCount = notifications ? notifications.split("||").length : 0;
    console.log("🔢 Počet notifikácií:", unreadCount);

    if (sessionStorage.getItem("notifications_seen") !== "true") {
        localStorage.setItem("unread_notifications", unreadCount.toString());
        window.dispatchEvent(new Event("storage"));
    }

    const notificationList = document.getElementById("notification-list");
    if (!notificationList) {
        console.warn("⚠️ Element #notification-list neexistuje, nemôžem vkladať notifikácie.");
        return;
    }

    notificationList.innerHTML = notifications.split("||").map((msg) => `
        <li class="notification-item unread">
            <div class="notification-box">${msg}</div>
        </li>
    `).join("");

    setTimeout(() => {
        if (sessionStorage.getItem("notifications_seen") === "true") {
            console.log("🔵 Označujem prečítané správy...");
            document.querySelectorAll(".notification-item").forEach(item => {
                item.classList.add("read");
                item.classList.remove("unread");
            });
        }
    }, 500);
});


